import activity from './_Admin/activity.json';
import admin from './_Admin/admin.json';
import applications from './_Admin/applications.json';
import chatbots from './_Admin/chatbots.json';
import companies from './_Admin/companies.json';
import dashboard from './_Admin/dashboard.json';
import reportFilters from './_Admin/reportFilters.json';
import reports from './_Admin/reports.json';
import roles from './_Admin/roles.json';
import settings from './_Admin/settings.json';
import users from './_Admin/users.json';
import common from './common.json';
import departments from './departments.json';
import header from './header.json';
import landing from './landing.json';
import login from './login.json';
import profile from './profile.json';

const entries = [
  common,
  header,
  login,
  landing,
  admin,
  applications,
  reports,
  activity,
  dashboard,
  users,
  roles,
  reportFilters,
  profile,
  companies,
  departments,
  settings,
  chatbots,
];

const en: Record<string, unknown> = {};
entries.forEach(lang => {
  Object.assign(en, lang);
});

export default en;
